import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    emailTrsanslations: [],
    notificationLanguages: []
}

const getters = {
    getEmailTrsnalations: (state) => state.emailTrsanslations,
    getAllNotificationLanguageList: (state) => state.notificationLanguages
}

const actions = {

    async getEmailNotificationTranslationList( context, data ) {
        await axios.get(`${backendUrl()}/getEmailNotificationTranslationList`,
        {
            params: {
                page: data.page,
				per_page: data.per_page,		
                langCode: data.langCode,
                stringId: data.stringId,
                notification: data.notification
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setEndUserEmailForm', response.data)
        })
    },

    async getNotificationLanguages( context, data ) {
        await axios.get(`${backendUrl()}/getNotificationLanguages`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setNotificationLanguages', response.data)
        })
    },
    async updateEmailNotification( context, data ) {
        await axios.post(`${backendUrl()}/updateEmailNotification`,
        {
            stringId: data.stringId,
            notification: data.notification,
            languageCode: data.languageCode
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async addEmailNotification( context, data ) {
        await axios.post(`${backendUrl()}/addEmailNotification`,
        {
            stringId: data.stringId,
            notification: data.notification,
            languageCode: data.languageCode
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async clearEmailNotification( context, data ) {
        await axios.post(`${backendUrl()}/clearEmailNotification`,
        {
            stringId: data.stringId,
            languageCode: data.languageCode
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async deleteEmailNotification( context, data ) {
        await axios.post(`${backendUrl()}/deleteEmailNotification`,
        {
            stringId: data.stringId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })     
    }
}

const mutations = {
    setEndUserEmailForm: (state, emailTrsanslations) => (state.emailTrsanslations = emailTrsanslations),
    setNotificationLanguages: (state, notificationLanguages) => (state.notificationLanguages = notificationLanguages)
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
  